import * as v from "valibot";

/** The windows the stats views offer: a day, a week, a month, and the whole 90-day retention. */
export const ADMIN_STATS_PERIODS = ["day", "week", "month", "all"] as const;
export type AdminStatsPeriod = (typeof ADMIN_STATS_PERIODS)[number];

export const ADMIN_STATS_PERIOD_DAYS: Record<AdminStatsPeriod, number> = { day: 1, week: 7, month: 30, all: 90 };

export const adminStatsPeriodDto = v.picklist(ADMIN_STATS_PERIODS);

export const adminStatsCountsDto = v.object({
  viewCount: v.number(),
  readCount: v.number(),
});
export type AdminStatsCounts = v.InferOutput<typeof adminStatsCountsDto>;

export const adminArticleStatsRequest = {
  authorAlias: v.pipe(v.string(), v.minLength(1), v.maxLength(100)),
  articleId: v.pipe(v.string(), v.minLength(1), v.maxLength(100)),
  period: adminStatsPeriodDto,
};

export const adminArticleStatsResponse = {
  stats: adminStatsCountsDto,
};

export const adminAuthorStatsRequest = {
  authorAlias: v.pipe(v.string(), v.minLength(1), v.maxLength(100)),
  period: adminStatsPeriodDto,
};

export const adminAuthorStatsResponse = {
  stats: adminStatsCountsDto,
  articles: v.array(
    v.object({
      articleId: v.string(),
      title: v.string(),
      viewCount: v.number(),
      readCount: v.number(),
    }),
  ),
};

export const adminRequestCountsRequest = {
  /** `YYYY-MM-DD`, UTC. */
  day: v.pipe(v.string(), v.regex(/^\d{4}-\d{2}-\d{2}$/, "Use YYYY-MM-DD")),
};

export const adminRequestCountDto = v.object({ app: v.string(), version: v.string(), count: v.number() });
export type AdminRequestCount = v.InferOutput<typeof adminRequestCountDto>;

/** A day's API requests by client (`web`, `ios`, `android`, `unknown`) and version, busiest first. */
export const adminRequestCountsResponse = {
  day: v.string(),
  rows: v.array(adminRequestCountDto),
  total: v.number(),
};
